// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1267":"378557c3","1918":"8bd868ec","2118":"11c5b3d1","2885":"59d9d7d6","2889":"ce257d01","3131":"9edcb704","7722":"53df9ccd"}[chunkId] + ".chunk.css";
};